import Form from './form';

window.addEventListener('DOMContentLoaded', (event) => {
	Form();
});
